import { Base, base } from "./base"
import { ButtonAliases, buttonAliases } from "./buttonAliases"
import { TextAliases, baseTextAliases } from "./textAliases"

export interface FontWeights extends Base {
  button: ButtonAliases
  text: TextAliases
}

export const fontWeights: FontWeights = {
  ...base,
  button: buttonAliases,
  text: baseTextAliases,
}
